import type { TitledItem } from './TitledListSection';
import { TitledListSection } from './TitledListSection';
import {
  useRorosCoreValues,
  useRorosCoreValueCreate,
  useRorosCoreValueUpdate,
  useRorosCoreValueRemove,
  useRorosCoreValueReorder,
} from '@/hooks/roros/overarching';
import type { RorosCoreValueDTO } from '@/types/roros/overarching';
import { t } from '@/lib/i18n';

export function CoreValuesSection() {
  const q = useRorosCoreValues({ pageSize: '100' });
  const items = ((q.data as unknown) ?? []) as RorosCoreValueDTO[];
  return (
    <TitledListSection<RorosCoreValueDTO>
      title={t('Core Values')}
      emptyHint={t('No core values yet.')}
      items={items}
      useCreate={useRorosCoreValueCreate}
      useUpdate={useRorosCoreValueUpdate}
      useRemove={useRorosCoreValueRemove}
      useReorder={useRorosCoreValueReorder}
      includeImage
    />
  );
}
